import BootstrapButton from "@/components/form/BootstrapButton"
import TextSelectForm from "@/components/form/TextSelectForm"
import Icon from "@/components/Icon"
import PlainIconButton from "@/components/PlainIconButton"
import { faCirclePlus, faTimes } from "@fortawesome/free-solid-svg-icons"
import { css } from "vite-css-in-js"
import { computed, ref } from "vue"
import { defineComponent, inferProps, type ReactiveComponent } from "vue-utils"

interface Props {
	options: string[]
	recipients: string[]
	setRecipients(recipients: string[]): void
}

const listStyles = css`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(24rem, 1fr));

	list-style: none;
	padding: 0;
	margin: 0;

	& > li {
		display: grid;
		grid-template-columns: max-content 1fr;
		gap: 0.125rem;

		& > button {
			color: var(--color-error);

			&:hover {
				color: darkred;
				svg {
					color: inherit;
				}
			}
		}
	}
`

const SelectRecipients: ReactiveComponent<Props> = (props) => {
	const addingValue = ref(false)
	const options = computed(() => {
		const options = new Set(props.options)
		for (const recipient of props.recipients) {
			options.delete(recipient)
		}
		return Array.from(options).sort()
	})

	function add(recipient: string) {
		const recipients = new Set(props.recipients)
		recipients.add(recipient)

		props.setRecipients(Array.from(recipients))
		addingValue.value = false
	}

	function remove(recipient: string) {
		const recipients = new Set(props.recipients)
		recipients.delete(recipient)

		props.setRecipients(Array.from(recipients))
	}

	return () => (
		<div class="flex flex-col spacing-2 flex-1 overflow-auto">
			<p class="my-0">Email addresses added here will be forwarded a copy of all files uploaded, on your behalf.</p>

			{props.recipients.length > 0 && (
				<ul class={listStyles}>
					{props.recipients.map((recipient) => (
						<li key={recipient}>
							<PlainIconButton icon={faTimes} title="Remove" onClick={() => remove(recipient)} />
							<span>{recipient}</span>
						</li>
					))}
				</ul>
			)}
			{addingValue.value ? (
				<div class="px-1">
					<TextSelectForm
						cancel={() => (addingValue.value = false)}
						noOptionsText="Add new recipient..."
						options={options.value}
						placeholder="Enter email address..."
						select={add}
						inputAttributes={{ type: "email", maxlength: 254 }}
						mustMatch={false}
					/>
				</div>
			) : (
				<div>
					<BootstrapButton type="button" color="success" onClick={() => (addingValue.value = true)}>
						<Icon icon={faCirclePlus} />
						Add Recipient
					</BootstrapButton>
				</div>
			)}
		</div>
	)
}

export default defineComponent(SelectRecipients, inferProps<Props>())
